module.exports = __webpack_public_path__ + "static/startstory-87d88002d947ea3792840bebd9611ed8.gif";